import React from 'react'

function AcademicYears() {
  return (
    <div>AcademicYears</div>
  )
}

export default AcademicYears